import { useLocation, useNavigate, useRouteError } from "react-router-dom";
import { RouteErrorRecoveryView } from "../../../../../../shared/frontend/feedback/RouteErrorRecoveryView";
import { requestManualAppReload } from "../system/appReloadCoordinator";
import { showClientErrorDetails, useClientErrorRecoveryLabels } from "./clientErrorRecovery";
import { postClientErrorOnce } from "./clientErrorReporter";

/** errorElement des Routers: Fehler aus Routen (z. B. lazy geladene Seiten). */
export function RouteErrorFallback() {
  const routeError = useRouteError();
  const location = useLocation();
  const navigate = useNavigate();
  const labels = useClientErrorRecoveryLabels();
  return (
    <RouteErrorRecoveryView
      currentPath={location.pathname}
      labels={labels}
      reportError={postClientErrorOnce}
      routeError={routeError}
      showDeveloperDetails={showClientErrorDetails()}
      // "/" löst die persönliche Startseite auf (Plattform-Admin, gespeicherte Startseite, sonst /overview).
      onBackToDashboard={() => navigate("/", { replace: true })}
      onReload={requestManualAppReload}
    />
  );
}
